<template>
  <f7-page
    @page:init="onPageInit"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore"
  >
    <f7-navbar :back-link="$t('back')">
      <f7-nav-title>{{ $t("payout") }}</f7-nav-title>
      <langButton></langButton>
    </f7-navbar>
    <f7-toolbar position="bottom">
      <f7-link></f7-link>
      <f7-button link href="/AddPayout" raised fill color="red"
        >我要提款</f7-button
      >
    </f7-toolbar>
    <f7-list
      media-list
      virtual-list
      :virtual-list-params="{
        height: theme.ios ? 63 : theme.md ? 73 : 77,
      }"
    >
      <f7-list-item
        swipeout
        :header="formatDate(item.Created)"
        :footer="item.Remark"
        v-for="(item, index) in list"
        :key="index"
        ><template #title
          ><span :class="`sttext st${item.Status}`">{{
            $t("ShopPayoutStatus." + item.Status)
          }}</span></template
        ><template #after
          ><span class="text_red">s${{ item.Amount }}</span></template
        >
        <f7-swipeout-actions right v-if="item.Status==1">
          <f7-swipeout-button color="red" overswipe @click="itemCancel(item.Id)"
            >取消申请</f7-swipeout-button
          >
        </f7-swipeout-actions></f7-list-item
      >
    </f7-list>
  </f7-page>
</template>
<script>
import util from "util/date";
import { getShopPayoutList, ShopPayoutCancel } from "@/api/api";
import { theme, f7 } from "framework7-vue";

export default {
  props: {
    f7route: Object,
  },
  data() {
    return {
      theme,
      allowInfinite: true,
      showPreloader: false,
      list: [],
      total: 0,
      page: 1,
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    itemCancel(id) {
      f7.dialog.confirm("确认取消吗？", "提示", () => {
        ShopPayoutCancel({ Id: id }).then((res) => {
          if (res.data.success) {
            this.getList(true);
          }
        });
      });
    },
    loadMore() {
      const self = this;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;

      self.showPreloader = true;
      self.getList();
    },
    //获取列表
    getList(isload = false) {
      const self = this;
      if (isload) {
        f7.preloader.show();
        self.page = 1;
        self.list = [];
      }
      let para = {
        page: this.page,
        key: window.localStorage.Shop_Id,
      };
      getShopPayoutList(para).then((res) => {
        self.list = this.list.concat(res.data.response.data);
        f7.preloader.hide();
        self.showPreloader = false;
        if (res.data.response.data.length > 0) {
          self.page++;
          self.allowInfinite = true;
        }
      });
    },
    onPageInit() {
      this.getList(true);
    },
  },
};
</script>
<style scoped>
.sttext{
  font-weight: initial;
}
.st1 {
  color: orange !important;
}

.st2 {
  color: limegreen !important;
}

.st3 {
  color: dimgray !important;
}

.st4 {
  color: tomato !important;
}

</style>